function Amount({amount}) {


    return <div className="lib_amount"><div>{amount}</div></div>


}

export default Amount;